import React from 'react';
import { CheckboxesTags, SelectTypeAutocomplete } from 'components';
import { selectTypeEnums } from '../../attributes/constnats';

export const SelectElement = ({ item, value, onChange, readOnly }) => {
    const handleSelectChange = (eventOrValue) => {
        if (readOnly) return;
        const newVal = eventOrValue?.target ? eventOrValue.target.value : eventOrValue;
        onChange(newVal);
    };

    const options = (item?.properties?.options || []).filter((opt) => opt.name && opt.name.trim() !== '');
    return (
        <div className="form-body-select-element">
            {item?.defaultDateType === selectTypeEnums.MULTIPLE && (
                <CheckboxesTags
                    handleChange={(val) => handleSelectChange(val)}
                    name={item?.name}
                    renderValue={(i) => i?.name}
                    value={value || []}
                    permissionsList={options?.map((opt) => ({ ...opt, name: opt?.name, id: opt?.id }))}
                    uiType={'tableFilter'}
                    notShowError={true}
                    styles={{ width: 'auto' }}
                    placeholder={value?.length ? value?.map((i) => `${i?.name}`).join(', ') : (item?.placeholder || '')}
                    disabled={readOnly}
                />
            )}

            {item?.defaultDateType === selectTypeEnums.SINGLE && (
                <SelectTypeAutocomplete
                    handleSelect={(val) => handleSelectChange(val?.target?.value)}
                    name={item?.name}
                    defaultSelected={value}
                    list={options?.map((opt) => ({ ...opt, name: opt?.name, id: opt?.id }))}
                    renderAllValue={true}
                    renderValue={(i) => i?.name}
                    defaultValue={value?.id}
                    uiType={'tableFilter'}
                    noError={true}
                    disabled={readOnly}
                    placeholder={item?.placeholder || ''}
                />
            )}
        </div>
    );
};
